const ua = () => {
    const _ua = navigator.userAgent.toLowerCase();

    if (/android/i.test(_ua)) {
        document.body.setAttribute("data-android", "1");
    }
    if (/windows/i.test(_ua)) {
        document.body.setAttribute("data-windows", "1");
    }
    if (_ua.indexOf("safari") !== -1 && _ua.indexOf("chrome") === -1 && _ua.indexOf("edge") === -1) {
        document.body.setAttribute("data-safari", "1");
    }
};

export { ua };
